class LoansCatalogCardButtonsController {
  constructor() {
  }
}

export default LoansCatalogCardButtonsController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCardButtons/loansCatalogCardButtons.controller.js